import {nombreDeAcciones} from "constantes/nombreDeAcciones";

// const datosDelMedioEscritoGeneral = {
//     nombreDelMedioEscrito: "La MEJOR NOTICIA",
//     distribucion: {id: 1, name: "Gratuita"},
//     circulacion: {id: 1, name: "Diaria"},
//     logoDelMedio: "",
//     descripcionDelMedio: "Todo en noticias",
//     correoElectronico: "mejorNoticia@gmail.com",
//     diasDeAnticipacion: "15",
//     comentarioEspecificaciones: "mejores noticias a mostrar",
//     tipoEscrito : {id: 1, name: "Periodico"}
// }

// const datosDeLaRadioGeneral = {
//     nombreDeLaRadio: "La sabrosona No.1",
//     estacion: "97.5",
//     frecuencia: {id: 1, name: "AM"},
//     logoRadio: "",
//     descripcionRadio: "Todo en musica",
//     correoElectronico: "lasabrosona@gmail.com",
//     diasDeAnticipacion: "15",
//     comentarioEspecificaciones: "mucho que comentar",
//     estaRegistrandoRadio : "1"
// }


// const datosDelCanalGeneral = {
//     nombreDelCanal: "Noti Canal",
//     numeroDelCanal: "30",
//     logoCanal: "sfasf",
//     descripcionCanal: "Noticias al día",
//     correoElectronico: "noti_canal@gmail.com",
//     diasDeAnticipacion: "23",
//     comentarioEspecificaciones: "ningun comentario",
//     estaRegistrandoCanal : "1"
// }

// const datosDemograficosGeneral = {
//     ratingCanal: 4.2,
//     alcancePersonas: 500000,
//     hombres: 50,
//     mujeres: 50,
//     alto: 30,
//     medio: 20,
//     bajo: 50,
//     edades: []
// }

// const tarifarioYDisponibilidadGeneral = {
//     julio: "20.20",
//     agosto: "10.10",
//     septiembre: "30.40",
//     octubre: "50",
//     noviembre: "70",
//     diciembre: "90",
//     promedio: 0,
//     disponibilidades: [], // fECHA_DESDE, FECHA_HASTA Y CANTIDAD_DISPONIBLE
// }


const datosDelMedioEscritoGeneral = {
    nombreDelMedioEscrito: "",
    distribucion: null,
    circulacion: null,
    logoDelMedio: "",
    descripcionDelMedio: "",
    correoElectronico: "",
    diasDeAnticipacion: "",
    comentarioEspecificaciones: "",
    tipoEscrito : null
}

const datosDeLaRadioGeneral = {
    nombreDeLaRadio: "",
    estacion: "",
    frecuencia: null,
    logoRadio: "",
    descripcionRadio: "",
    correoElectronico: "",
    diasDeAnticipacion: "",
    comentarioEspecificaciones: "",
    estaRegistrandoRadio : ""
}

const datosDelCanalGeneral = {
    nombreDelCanal: "",
    numeroDelCanal: "",
    logoCanal: "",
    descripcionCanal: "",
    correoElectronico: "",
    diasDeAnticipacion: "",
    comentarioEspecificaciones: "",
    estaRegistrandoCanal : "2"
}

const tarifarioYDisponibilidadGeneral = {
    julio: "",
    agosto: "",
    septiembre: "",
    octubre: "",
    noviembre: "",
    diciembre: "",
    promedio: 0,
    disponibilidades: [], // fECHA_DESDE, FECHA_HASTA Y CANTIDAD_DISPONIBLE
}

const datosDemograficosGeneral = {
    ratingCanal: "",
    alcancePersonas: "",
    hombres: "",
    mujeres: "",
    alto: "",
    medio: "",
    bajo: "",
    edades: []
}

const coberturaGeneral = {
    listadoDeCoberturas: [],
}

const initialState = {
    datosDelMedioEscrito: datosDelMedioEscritoGeneral,
    datosDeLaRadio: datosDeLaRadioGeneral,
    datosDelCanal: datosDelCanalGeneral,
    tarifarioYDisponibilidad: tarifarioYDisponibilidadGeneral,
    datosDemograficos: datosDemograficosGeneral,
    cobertura: coberturaGeneral,
    activeStep: 0,
    numberStep: 1,
};

export default (state = initialState, action ) => {
    switch (action.type) {

        case nombreDeAcciones.SETEAR_DATOS_DEL_MEDIO_ESCRITO:
            return {
                ...state,
                datosDelMedioEscrito: {...action.payload.datosDelMedioEscrito},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SETEAR_DATOS_DE_LA_RADIO:
            return {
                ...state,
                datosDeLaRadio: {...action.payload.datosDeLaRadio},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SETEAR_DATOS_DEL_CANAL:
            return {
                ...state,
                datosDelCanal: {...action.payload.datosDelCanal},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SETEAR_TARIFARIO_Y_DISPONIBILIDAD:
            return {
                ...state,
                tarifarioYDisponibilidad: action.payload.tarifarioYDisponibilidad,
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SETEAR_DATOS_DEMOGRAFICOS:
            return {
                ...state,
                datosDemograficos: {...action.payload.datosDemograficos},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SETEAR_DATOS_COBERTURAS:
            return {
                ...state,
                cobertura: {...action.payload.cobertura},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SET_DATA_ACTIVE_AND_NUMBER_STEP:
            return {
                ...state,
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER:
            return {
                datosDelMedioEscrito: datosDelMedioEscritoGeneral,
                datosDeLaRadio: datosDeLaRadioGeneral,
                datosDelCanal: datosDelCanalGeneral,
                tarifarioYDisponibilidad: tarifarioYDisponibilidadGeneral,
                datosDemograficos: datosDemograficosGeneral,
                cobertura: coberturaGeneral,
                activeStep: 0,
                numberStep: 1,
            }

        default:
            return state;
    }
}